module.exports = __webpack_public_path__ + "img/Start.ca_Logo.1f20b75c.png";